// клиентская точка входа (создает и монтирует приложение в DOM)
import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from './app';
import { parse as parseCookies } from 'cookie';

// специфичная для клиента логика загрузки...

const { app, router, store } = createApp(parseCookies(document.cookie), process.env.API_URL);

if (window.__INITIAL_STATE__) {
  // инициализируем состояние хранилища данными, внедрёнными на сервере
  store.replaceState(window.__INITIAL_STATE__);
}

// маршрутизатор должен заранее разрешить все асинхронные компоненты маршрутов для правильного вызова хуков компонентов
router.onReady(() => {
  // предполагается, что у корневого элемента в шаблоне App.vue есть элемент с `id="app"`
  app.$mount('#app', true)
});
